import script from "./StationRegistrationSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./StationRegistrationSection.vue?vue&type=script&lang=ts&setup=true"

import "./StationRegistrationSection.vue?vue&type=style&index=0&id=703cd7b0&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-703cd7b0"]])

export default __exports__